define("ember-svg-jar/inlined/social-inbox", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = _exports.default = {
    "content": "<path fill-rule=\"evenodd\" d=\"M25.123 10.428h-1.827L20.13 12.64a.496.496 0 01-.78-.406v-1.806h-.992a1.852 1.852 0 01-1.877-1.877V3.486c0-1.056.82-1.877 1.877-1.877h6.765A1.853 1.853 0 0127 3.486v5.065c0 1.056-.82 1.877-1.877 1.877zm-2.26-1.913a.493.493 0 00-.278.086l-1.322.9v-.49a.496.496 0 00-.496-.496h-2.374V3.522h6.695v4.993h-2.224z\" clip-rule=\"evenodd\"/><path fill-rule=\"evenodd\" d=\"M13.383 1.956a1.227 1.227 0 010 2.455h-8.59c-.677 0-1.227.55-1.227 1.227V23.71c0 .678.55 1.227 1.227 1.227h.87a4.614 4.614 0 014.614-4.567h4.614a4.614 4.614 0 014.613 4.567h.684c.678 0 1.228-.549 1.228-1.227v-8.59a1.227 1.227 0 012.454 0v8.59a3.681 3.681 0 01-3.682 3.682H4.793a3.681 3.681 0 01-3.681-3.682V5.638a3.681 3.681 0 013.681-3.682h8.59zm3.814 22.982a2.307 2.307 0 00-2.306-2.262h-4.614a2.307 2.307 0 00-2.306 2.262h9.226z\" clip-rule=\"evenodd\"/><path fill-rule=\"evenodd\" d=\"M7.74 14.833a4.844 4.844 0 119.688 0 4.844 4.844 0 01-9.689 0zm4.844-2.537a2.538 2.538 0 100 5.075 2.538 2.538 0 000-5.075z\" clip-rule=\"evenodd\"/>",
    "attrs": {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "28",
      "height": "28",
      "viewBox": "0 0 28 28"
    }
  };
});